module.exports = require("@cloudbase/signature-nodejs");